// Google Analytics event tracking utility
// GA4 Measurement ID: G-CTKY6VT4E7

export function trackEvent(eventName, params = {}) {
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }
}

export function trackPageView(path, title) {
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: title,
    });
  }
}

// Lead conversion events
export const GA_EVENTS = {
  CONTACT_FORM_SUBMIT: 'contact_form_submit',
  QUOTE_CALCULATED: 'quote_calculated',
  SAMPLE_REQUESTED: 'sample_requested',
  GET_STARTED_CLICK: 'get_started_click',
  CLIENT_REGISTERED: 'client_registered',
  PROJECT_SUBMITTED: 'project_submitted',
  WHATSAPP_CLICK: 'whatsapp_click',
  TELEGRAM_CLICK: 'telegram_click',
  SERVICE_PAGE_VIEW: 'service_page_view',
  PHONE_CLICK: 'phone_click',
};
